// =============================================
// LIGHTBOX — Gallery image zoom
// =============================================

(function () {
  var overlay = document.getElementById('lightbox');
  if (!overlay) return;

  var img     = overlay.querySelector('.lightbox__img');
  var caption = overlay.querySelector('.lightbox__caption');
  var close   = overlay.querySelector('.lightbox__close');
  var prev    = overlay.querySelector('.lightbox__prev');
  var next    = overlay.querySelector('.lightbox__next');

  var images  = [];
  var current = 0;

  // ── Collect gallery images ──────────────────────────────────────────────
  function init() {
    var grids = document.querySelectorAll('.gallery-grid');
    grids.forEach(function (grid) {
      grid.querySelectorAll('img').forEach(function (el) {
        var idx = images.length;
        images.push({ src: el.src, alt: el.alt });
        el.style.cursor = 'zoom-in';
        el.addEventListener('click', function () { open(idx); });
      });
    });
  }

  // ── Open ────────────────────────────────────────────────────────────────
  function open(idx) {
    current = idx;
    show(current);
    overlay.classList.add('lightbox--visible');
    document.body.style.overflow = 'hidden';
    overlay.focus();
  }

  // ── Close ───────────────────────────────────────────────────────────────
  function closeLB() {
    overlay.classList.remove('lightbox--visible');
    document.body.style.overflow = '';
    img.src = '';
  }

  // ── Show image ──────────────────────────────────────────────────────────
  function show(idx) {
    var item = images[idx];
    img.classList.remove('lightbox__img--loaded');
    img.src = item.src;
    img.alt = item.alt;
    caption.textContent = item.alt;

    img.onload = function () {
      img.classList.add('lightbox__img--loaded');
    };

    // Arrow visibility
    prev.style.display = idx > 0                  ? '' : 'none';
    next.style.display = idx < images.length - 1  ? '' : 'none';
  }

  // ── Events ──────────────────────────────────────────────────────────────
  close.addEventListener('click', closeLB);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeLB();
  });

  prev.addEventListener('click', function () {
    if (current > 0) show(--current);
  });

  next.addEventListener('click', function () {
    if (current < images.length - 1) show(++current);
  });

  document.addEventListener('keydown', function (e) {
    if (!overlay.classList.contains('lightbox--visible')) return;
    if (e.key === 'Escape')     closeLB();
    if (e.key === 'ArrowLeft')  { if (current > 0)                 show(--current); }
    if (e.key === 'ArrowRight') { if (current < images.length - 1) show(++current); }
  });

  init();
})();
